import { Quantile as QuantileScale } from '@antv/scale';
export const Quantile = (options) => {
    return new QuantileScale(options);
};
Quantile.props = {};
//# sourceMappingURL=quantile.js.map